import Box from '@mui/material/Box'

import type { FilterOption, GroupedFilterOption } from '@models/Filter'

import { DashboardCard } from '../../../aansluiting/dashboard/components/DashboardCard'
import { Grid } from '../../../theme/components/Grid'
import { initialState } from '../../projecten/services/searchProjecten'
import { useKpi } from '../hooks/useKpi'
import type { Kpi } from '../types/Kpi'

import { ProcesstappenFilters } from './ProcesstappenFilters'

interface Props {
  onClickTile: (query: any, url: any) => void
  filterOptions: {
    labels: FilterOption[]
    hoofdleiding: {
      gebieden: FilterOption[]
      netbeheerders: string[]
      verantwoordelijken: GroupedFilterOption[]
      typeWerkTypes: string[]
    }
  }
}

export const Processtappen = ({ onClickTile, filterOptions }: Props) => {
  const {
    data: kpis,
    filters,
    initialFilters,
    onChangeFilters,
    onRefresh,
    onReset,
  } = useKpi()

  const onClick = (kpi: Kpi) => {
    const { gebied, labels, netbeheerder, myList, verantwoordelijke } = filters

    onClickTile(
      {
        filters: {
          ...initialState.query.filters,
          gebied,
          labels,
          processtap: [kpi.statusText],
          netbeheerder,
          myList,
          verantwoordelijke,
        },
        page: initialState.query.page,
        sort: initialState.query.sort,
      },
      '/hoofdleiding/projecten',
    )
  }

  return (
    <>
      <ProcesstappenFilters
        filters={filters}
        onChange={onChangeFilters}
        initialFilters={initialFilters}
        onRefresh={onRefresh}
        onReset={onReset}
        filterOptions={filterOptions}
      />
      <Box sx={{ p: '50px' }}>
        <Grid sx={{ width: '100%' }} container spacing={2}>
          {kpis
            .filter((kpi) => !kpi.code)
            .map((kpi) => (
              <Grid key={kpi.statusText}>
                <DashboardCard
                  onClick={() => onClick(kpi)}
                  label={kpi.statusText}
                  count={kpi.total}
                />
              </Grid>
            ))}
        </Grid>
      </Box>
    </>
  )
}
